import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestDataArray } from 'src/types/requestData';
import { getRequest } from 'src/utils/request';

const mapTaxClasses = (attributes: UCM.TaxClassRawType, id: string) => {
  return {
    id,
    label: attributes.name,
    value: attributes.code,
  };
};

const getTaxClasses = async () => {
  const { data } = await getRequest<RequestDataArray<UCM.TaxClassRawType>>(
    API.GET.taxClasses,
  );
  return data?.data?.map(({ attributes, id }) => mapTaxClasses(attributes, id));
};

export const useGetTaxClasses = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.TAX_CLASSES],
    queryFn: () => getTaxClasses(),
  });
};
